export default __webpack_public_path__ + "static/imgR-f4b4884cc9585ac90658d55704969f65.png";